<template>
    <auth-layout id="login-page" class="login-page">
        <div class="col-12 col-md-6 col-lg-4" v-if="!this.$root.whitelabel.isLeads()">
            <div class="row py-4">
                <div class="col-12">
                    <h1>{{ $t('login.title')}}</h1>
                </div>
            </div>

            <auth-closed-shop-info-box></auth-closed-shop-info-box>

            <section id="login-form" class="login-form">
                <div class="row">
                    <div class="mb-1 col-12">
                        <b-form-group
                            :label="$t('cdb.profile.form.email.label')"
                            label-for="email"
                        >
                            <input id="email" class="form-control" :placeholder="$t('cdb.profile.form.email.label')" type="email" v-model="email"/>
                        </b-form-group>
                        <b-form-group
                            :label="$t('cdb.profile.form.password.label')"
                            label-for="password"
                        >
                            <input id="password" class="form-control" :placeholder="$t('cdb.profile.form.password.label')" type="password" v-model="password" v-on:keyup.enter="handleLogin"/>
                            <div v-if="error" class="text-danger py-1">{{ $t('login.error')}}</div>
                        </b-form-group>
                    </div>
                    <div class="col-12 text-center mb-4">
                        <b-link :to="$getUrl('password_forget')">{{  $t('meta.auth.forgetPassword.title') }}?</b-link>
                    </div>
                    <div class="btn-container col-12">
                        <button class="btn btn-primary w-100" type="button" @click="handleLogin" v-if="!isLoading">{{ $t('login.submit')}}</button>
                        <button class="btn btn-primary w-100 disabled" type="button" v-else>{{ $t('co.button.loading') }}</button>
                        <b-link class="btn btn-link" v-if="!isB2b" :to="$getUrl('register')">{{ $t('login.toRegister')}}</b-link>
                    </div>
                </div>
            </section>
        </div>
        <div v-else>
            <div class="row container mt-1 margin-center" style="height: 50px;">
                <b-button @click="$goTo('catalog')">
                    {{$t('co.main.redirect')}}
                </b-button>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from "../../layouts/AuthLayout.vue";
import AuthClosedShopInfoBox from "../../components/molecules/AuthClosedShopInfoBox.vue";
import {
    BLink, BFormGroup
} from "bootstrap-vue";

export default {
    components: {
        AuthLayout,
        BLink, BFormGroup,
        AuthClosedShopInfoBox
    },
    data() {
        return {
            email: '',
            password: '',
            error: '',
            errorTimer: '',
            isLoading: false
        }
    },
    computed: {
        isB2b() {
            return this.$root.whitelabel?.state?.settings?.is_b2b
        }
    },
    methods: {
        handleLogin() {
            this.isLoading = true
            this.$axios.get('/sanctum/csrf-cookie').then(() => {
                this.$axios.post('api/login', {
                    email: this.email,
                    password: this.password,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.user.loggedIn();
                            this.$root.initWhitelabel();

                            localStorage.setItem('selectedCompany', JSON.stringify(response.data.selectedCompany));

                            if (response.data.mailVerified) {
                                this.$root.user.verifiedMail()

                                if (this.$route.query.isInCheckout === "true") {
                                    this.$axios.post('api/v1/checkout/init_checkout', {
                                        vehicle_uuid: localStorage.selectedProduct,
                                        mileage: localStorage.selectedMileage,
                                        duration: localStorage.selectedDuration,
                                        tier_uuid: localStorage.selectedTier
                                    })
                                        .then(response => {
                                            if (response.data) {
                                                this.$goTo('checkout', { identifier: response.data.data.identifier })
                                            } else {
                                                this.error = response.data.message
                                            }
                                        })
                                        .catch(error => {
                                            this.error = error.response.data.message
                                        });
                                } else {
                                    this.$goTo('catalog')
                                }
                            } else {
                                this.$goTo('account_not_verified')
                            }
                        } else {
                            this.error = response.data.message

                            clearTimeout(this.errorTimer);
                            this.errorTimer = setTimeout(() => {
                                this.error = '';
                            }, 10000);
                        }
                    })
                    .catch(error => {
                        this.error = error.response.data.message

                        clearTimeout(this.errorTimer);
                        this.errorTimer = setTimeout(() => {
                            this.error = '';
                        }, 10000);
                    }).finally( () => {
                        this.isLoading = false
                });
            })
        }
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.auth.login.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.auth.login.description') }
            ]
        }
    }
}
</script>
